import React, { useEffect, useState, useRef } from 'react'
import {
  Spin,
  Button,
  Collapse,
  Menu,
  Dropdown,
  Form,
  ConfigProvider,
} from 'antd'
import SelectField from 'components/SelectField'
import TableComponent from 'components/Table'
import { connect } from 'react-redux'
import SearchableColumn from 'components/Table/ColumnSearch'
import ActiveCreditList from './ActiveCreditList'
import DeactiveCreditList from './DeactiveCreditList'
import { financial } from "../../../../services/helper"
import CustomTooltip from "components/Tooltip"
import {
  Credit,
  getCredits,
  getCreditPlan,
  getCreditRealPlan,
  getCreditRealPlanPdf,
  getCreditPlanPdf,
  getCreditRealPlanExcel,
  getCreditPlanExcel
} from '../../../../services/Credits/Credits'
import '../../../Salary/components/SalaryList/index.scss'
import '../../../Salary/index.scss'
import '../../../Salary/components/Transfer/index.scss'
import '../../../Transfer/transfer.scss'
import '../../index.scss'
import Icon from '@ant-design/icons'
import {
  AccountMoreIco,
  TableIco,
  FactTableIco,
} from '../../../../../modules/CustomIcons'
import { CreditStatus } from 'pages/Credits/components/CreditStatus'
import { CustomDataEmpty } from 'components/customDataEmpty'
import ModalComponent from 'components/Modal'
import { Spinner } from 'constants/constants'
import { getCurrentCompany } from '../../../../services/user'
import { updateAccountNickname } from '../../../../services/Accounts/AccountNickname'

import { DataConvert } from 'components/Table/DataConvert'
import moment from 'moment'
import e from 'express';
import './index.scss';
import { useTranslation } from 'react-i18next'
import { useConveyer } from "@egjs/react-conveyer";

const { Panel } = Collapse
interface CreditListProps {
  className?: string
}

export const CreditList: React.FC<CreditListProps> = ({ className }) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  const [tableData, setTableData] = useState<Credit[]>()
  const [filteredData, setFilteredData] = useState<Credit[]>()
  const [deactiveFilteredData, setDeactiveFiltered] = useState<Credit[]>()
  const [isFiltered, setIsFiltered] = useState(false)
  const [deactiveTableData, setDeactiveTableData] = useState<Credit[]>()

  const [pageSize, setPageSize] = useState(7)
  const [panel, setPanel] = useState(false)
  const [creditsPlan, setCreditsPlan] = useState([])
  const [realCreditsPlan, setRealCreditsPlan] = useState([])
  const [tableModal, setTableModal] = useState(false)
  const [tableModalFact, setTableModalFact] = useState(false)
  const [sort, handleSorter] = useState({})
  const [tableLoading, setTableLoading] = useState(Spinner)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [expandedPanelTableKeys, setExpandedPanelTableKeys] = useState([])
  const [selectedCurrency, setSelectedCurrency] = useState(t("common.all"))
  const [firstRow, setFirstRow] = useState(false)
  const [isDropdownVisible, setDropdown] = useState(true)
  const [contractNum, setContractNum] = useState('')
  const [form] = Form.useForm()


  const [mainAmount, setMainAmount] = useState(0)
  const [interestAmount, setInterestAmount] = useState(0)
  const [paidAmount, setPaidAmount] = useState(0)

  // const [delayDay, setDelayDay] = useState(0)
  const [totalDebt, setTotalDebt] = useState(0)
  const [paidTotalint, setPaidTotal] = useState(0)
  const [debtPenalty, setDebtPenalty] = useState(0)
  const [intPenalty, setIntPenalty] = useState(0)
  const [factPaidAmount, setFactPaidAmount] = useState(0)
  const [loadingPdf,setLoadingPdf] = useState(false)
  const [loadingExcel,setLoadingExcel] = useState(false)
  const fetchData = async () => {
    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    const data = await getCredits(getCurrentCompany())
    const filter_active_data = data.filter(
      (row) => row.STATUS !== "Ödənilibdir" && row.STATUS !== "Погашено" && row.STATUS !== "Closed"
    )
    const filter_deactive_data = data.filter(
      (row) => row.STATUS === "Ödənilibdir" || row.STATUS === "Погашено" || row.STATUS === "Closed"
    )
    // let newData = Object.assign(filter_active_data, {key: 1});
    const newData = filter_active_data.map((object, index) => {
      return { ...object, key: index, isExpandable: false }
    })
    const deactiveData = filter_deactive_data.map((object, index) => {
      return { ...object, key: index, isExpandable: false }
    })

    setTableData(newData)
    setDeactiveTableData(deactiveData)

    setTableLoading({
      ...tableLoading,
      spinning: false,
    })
  }

  useEffect(() => {
    fetchData()
    // handlerealCreaditModal()
  }, [])

  // const filterHandler = (value: any, columnName: string) => {
  //   const filtered = tableData.filter((row) => {
  //     return row[columnName] == value
  //   })
  //   const filtereddeactive = deactiveTableData.filter((row) => {
  //     return row[columnName] == value
  //   })
  //   setIsFiltered(true)
  //   setFilteredData(filtered)
  //   setDeactiveFiltered(filtereddeactive)
  //   // setTableData(value === 'all' ? tableData : filtered)

  //   if (value == 'all') {
  //     form.resetFields(['CCY_NAME'])
  //     setIsFiltered(false)
  //   }
  // }

  const currencyFilter = [
    {
      label: t("common.all"),
      value: 'all',
    },
    {
      label: 'AZN',
      value: 'AZN',
    },
    {
      label: 'USD',
      value: 'USD',
    },
    {
      label: 'RUB',
      value: 'RUB',
    },
    {
      label: 'EUR',
      value: 'EUR',
    },
    {
      label: 'GBP',
      value: 'GBP',
    },
  ]

  const [filtereValues, setFilteredValues] = useState({ "col_2": "", "col_3": "" })

  const handleFilterColumn = (e: any, column: string) => {

    let newfiltereValues = filtereValues;

    if (column === 'CONTRACT') {
      newfiltereValues.col_2 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'CCY_NAME') {
      newfiltereValues.col_3 = e?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }


    if (tableData && deactiveTableData && filtereValues) {

      let filteredData;

      filteredData = tableData?.filter(sRow => sRow.CCY_NAME.toLowerCase().includes(filtereValues["col_3"]) && sRow.CONTRACT?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]));

      let filteredDataDeactive;

      filteredDataDeactive = deactiveTableData?.filter(sRow => sRow.CCY_NAME.toLowerCase().includes(filtereValues["col_3"]) && sRow.CONTRACT?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]));

      setFilteredData(filteredData)
      setDeactiveFiltered(filteredDataDeactive)
      setIsFiltered(true)

      if (filtereValues["col_3"] === 'all') {
        form.resetFields(['currency_filter'])
      }
    }

  }


  const handlecreditPlan = async (e: any) => {
    // setExpandedPanelTableKeys([])
    // setExpandedRowKeys([])
    let company = getCurrentCompany()
    let creditsPlan = await getCreditPlan(company, contractNum)

    if (creditsPlan) {
      //@ts-ignore
      setCreditsPlan(creditsPlan)
      setTableModal(!tableModal)
    }
  }

  const handlerealCreaditModal = async (e: any) => {
    // setExpandedPanelTableKeys([])
    // setExpandedRowKeys([])
    let company = getCurrentCompany()
    let creditsRealPlan = await getCreditRealPlan(company, contractNum)

    if (creditsRealPlan) {
      //@ts-ignore
      setRealCreditsPlan(creditsRealPlan)
      setTableModalFact(!tableModalFact)

    }
  }
  const handleMenuRecord = (e: any, contractNum: any) => {
    e.stopPropagation()
    e.preventDefault()
    // setDropdown(true)
    setContractNum(contractNum.CONTRACT)
   
  }
  const updateNickname = (e: any, row: any) => {
    // e.preventDefault()
    e.stopPropagation()
    setFirstRow(false)
    setExpandedRowKeys([])
    setExpandedPanelTableKeys([])
    let value = e.target.value.trim()
    let check_value = value

    const requestData = {
      IBAN: row['iban'],
      NICKNAME: check_value,
    }

    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    updateAccountNickname(requestData).then((res) => {
      fetchData()
    })
  }

  const columnsData = [
    {
      title: (
        <div style={{ display: 'block', width: 196 }}>
          {t("credits.creditName")}
          {/* <SearchableColumn
            onChange={(event: any) => handleFilterColumn(event, 'nickName')}
            onBlur={() => setIsFiltered(false)}
            large
            title={'Kreditin adı'}
          /> */}
        </div>
      ),
      render: (data: any, record: any) => {

        return (
          <p className="align_center not_open_popup">
            <div className={'not_open_popup account_edit_nickname'} id='account_edit_nickname' onClick={() => setFirstRow(true)}>
              <Form form={form}>
                <SearchableColumn
                  large
                  title={data ? (data.split('').length > 27
                    ? <CustomTooltip title={data}>{data}</CustomTooltip> : data)
                    : record['CREDIT_NAME']}
                  customIcon={true}
                  form={form}
                  maxLength={35}
                  allowClear={true}
                  // onClick={() => setFirstRow(true)}
                  value={data ? data : record['CREDIT_NAME']}
                  name={'nickName'}
                  /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                  onBlur={(e: any) => updateNickname(e, record)}
                />
              </Form>
            </div>
          </p>
        )
      },
      dataIndex: 'nickName',
      key: 'nickName',
      className: 'big-column',
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(true)
      //     },
      //   };
      // },
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = true;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = true;
              setTableData(newtableData);
            }
          },
        };
      },
      // sorter: (a:any, b:any) => a.depositName.localeCompare(b.depositName),
    },
    {
      title: (
        <div style={{ width: 180, marginLeft: 7 }}>
          <Form
            form={form}
          >
            <SearchableColumn
              onChange={(event: any) => handleFilterColumn(event, 'CONTRACT')}
              onBlur={() => setIsFiltered(false)}
              large
              title={t("credits.loanAgreementNo")}
              form={form}
              name={"contract"}
              filter={"searchfilter"}
            />
          </Form>
        </div>
      ),
      render: (text: string) => (
        <span className={'creditList__invoiceNumber'}>{text}</span>
      ),
      dataIndex: 'CONTRACT',
      key: 'CONTRACT',
      editable: false,
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      title: (
        <div className="flex" style={{ width: 102 }}>
          <div className="filterable-column">
            <Form form={form}>
              {t("home.currency")}
              <SelectField
                width={85}
                placeholder={t("common.all")}
                options={currencyFilter}
                className="status-select credit-status-select"
                onChange={(event: any) => handleFilterColumn(event, 'CCY_NAME')}
                name={'currency_filter'}
              />
            </Form>
          </div>
        </div>
      ),
      dataIndex: 'CCY_NAME',
      key: 'CCY_NAME',
      className: 'big-column',
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      title: (
        <div style={{ textAlign: 'center', width: '141px' }}>
          {t("credits.creditStatus")}
        </div>
      ),
      render: (text: string, record: any) => (
        <CreditStatus value={text} statusType={record?.STATUS} />
      ),
      dataIndex: 'STATUS',
      key: 'STATUS',
      editable: false,
      sorter: (a: any, b: any) => a.STATUS.localeCompare(b.STATUS),
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      title: (
        <div className={''} style={{ width: 116 }}>
          <span className={'credit-table__title credit-table__title-center'}>
            {t("credits.nextRepaymentDat.up")}
          </span>
          <span className={'credit-table__title credit-table__title-center'}>
            {' '}
            {t("credits.nextRepaymentDat.down")}
          </span>
        </div>
      ),
      dataIndex: 'NEXT_PAYMENT_DATE',
      key: 'NEXT_PAYMENT_DATE',
      editable: false,
      render: (text: string) => {

        return (
          <span className={'credit-table__text credit-table__title-center'}>
            {text ? moment(text, 'DD/MM/YYYY').format('DD.MM.YYYY') : '-'}
          </span>
        )
      },
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
      // render: (record: any, text: any) => {
      //   return moment(text).format('DD.MM.YYYY')
      // },
    },
    {
      title: (
        <div className={'credit-table__titleBox'} style={{ width: 116 }}>
          <span className={'credit-table__title credit-table__title-right'}>
            {t("credits.nextRepaymentAmount.up")}
          </span>
          <span className={'credit-table__title credit-table__title-right'}>
            {t("credits.nextRepaymentAmount.down")}
          </span>
        </div>
      ),
      render: (text: string) => {
        return (
          <span className={'credit-table__text credit-table__title-right'}>
            {financial(text)}
          </span>
        )
      },
      dataIndex: 'NEXT_PAYMENT_AMOUNT',
      key: 'NEXT_PAYMENT_AMOUNT',
      className: 'big-column',
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      title: (
        <div className={'credit-table__titleBox'} style={{ width: 116 }}>
          <span className={'credit-table__title credit-table__title-center'}>
            {' '}
            {t("credits.paidTotalMonth.up")}
          </span>
          <span className={'credit-table__title credit-table__title-center'}>
            {' '}
            {t("credits.paidTotalMonth.down")}
          </span>
        </div>
      ),
      render: (text: string) => {
        if (text === "/" || text === "0") {
          return (
            <span className={'credit-table__text credit-table__title-center'}>
              -
            </span>
          )
        } else {
          return (
            <span className={'credit-table__text credit-table__title-center'}>
              {text}
            </span>)
        }

      },
      dataIndex: 'PAID_TOTAL_MONTH',
      key: 'PAID_TOTAL_MONTH',
      className: 'big-column',
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      title: (
        <div className={'credit-table__titleBox'} style={{ width: 116 }}>
          <span className={'credit-table__title credit-table__title-right'}>
            {' '}
            {t("credits.outstandingPrincipalAmount.up")}
          </span>
          <span className={'credit-table__title credit-table__title-right'}>
            {' '}
            {t("credits.outstandingPrincipalAmount.down")}
          </span>
        </div>
      ),
      dataIndex: 'MAIN_BALANCE',
      render: (text: string) => (
        <span className={'credit-table__text credit-table__title-right'}>
          {financial(text)}
        </span>
      ),
      key: 'MAIN_BALANCE',
      className: 'big-column',
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(false)
      //     },
      //   };
      // },
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            }
          },
        };
      },
    },
    {
      key: 'action',
      width: 20,
      fixed: "right",
      className: "creditDetailColumn",
      render: (text: string, record: object) => {
        return (
          <Dropdown
            overlay={tableDropDown}
            trigger={['click']}
            // visible={false}
            placement="bottomRight"
          >
            <Button
              icon={<AccountMoreIco />}
              visible={false}
              className="transparent creditList__moreBtn"
              onClick={(e: any) => handleMenuRecord(e, record)}
            />
          </Dropdown>
        )
      },
      // onCell: () => {
      //   return {
      //     onClick: () => {
      //       setFirstRow(true)
      //     },
      //   };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "Ödənilibdir" || record.STATUS === "Погашено" || record.STATUS === "Closed") {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = true;
              setDeactiveTableData(neweActivetableData);
            } else {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = true;
              setTableData(newtableData);
            }
          },
        };
      },
    },
  ]

  const columnsModal = [
    {
      title: <span className={'creditModal__tableTitle'}>№</span>,
      render: (text: string, record: any, index: number) => (
        <span className={'creditModal__tableText'}>{index + 1}</span>
      ),
      width: 50,
      ellipsis: true,
      editable: false,
    },
    {
      title: <span className={'creditModal__tableTitle'} >{`${t("credits.repaymentDate.up")} ${t("credits.repaymentDate.down")}`}</span>,
      dataIndex: 'PAYMENT_DATE',
      key: 'PAYMENT_DATE',
      editable: false,
      // width: 60,
      render: (text: string) => {
        return <span className={'creditModal__tableText'}>{moment(text, 'DD/MM/YYYY').format('DD.MM.YYYY')}</span>
      }
    },
    {
      title: <div>
        <span className={'creditModal__tableTitle'} >{t("credits.countOfDelayedDays.up")}</span>
        <span className={'creditModal__tableTitle'} >{t("credits.countOfDelayedDays.down")}</span>
      </div>,
      render: (text: string) => {
        return <span className={'creditModal__tableText'}>{text}</span>
      },
      dataIndex: 'DELAY_DAY_COUNT',
      key: 'DELAY_DAY_COUNT',
      editable: false,
      ellipsis: true,
      width: 80,
      // width: 102
    },
    {
      title: (
        <span className={'creditModal__tableTitle'}>{t("credits.depthPrincipal.up") + " " + t("credits.depthPrincipal.down")}</span>
      ),
      dataIndex: 'MAIN_AMOUNT',
      key: 'MAIN_AMOUNT',
      editable: false,
      render: (text: string) => {
        const mainAmount = creditsPlan && creditsPlan.reduce((a: any, v) => a + v['MAIN_AMOUNT'], 0).toFixed(2)
        setMainAmount(mainAmount);
        return <span className={'creditModal__tableText'}>{financial(text)}</span>
      }
    },
    {
      title: <span className={'creditModal__tableTitle'}>{t("credits.interestAmount.up") + " " + t("credits.interestAmount.down")}</span>,
      dataIndex: 'INTEREST_AMOUNT',
      key: 'INTEREST_AMOUNT',
      render: (text: string) => {
        const interestAmount = creditsPlan && creditsPlan.reduce((a: any, v) => a + v['INTEREST_AMOUNT'], 0).toFixed(1);
        setInterestAmount(interestAmount)
        return <span className={'creditModal__tableText'}>{financial(text)}</span>
      }
      // sorter: (a:any, b:any) => a.status.localeCompare(b.status),
    },
    {
      title: <span className={'creditModal__tableTitle'}>{t("credits.repaymentAmount")}</span>,
      dataIndex: 'PAID_AMOUNT',
      key: 'PAID_AMOUNT',
      render: (text: string) => {
        const paidAmount = creditsPlan && creditsPlan.reduce((a: any, v) => a + v['PAID_AMOUNT'], 0).toFixed(1);
        setPaidAmount(paidAmount)
        return <span className={'creditModal__tableText'}>{financial(text)}</span>
      },
    },
  ]

  const columnsModalFact = [
    {
      title: <span className={'creditModal__tableTitleFact'} >№</span>,
      dataIndex: 'number',
      key: 'number',
      editable: false,
      // width: 50,
      ellipsis: true,
      render: (text: string, record: any, index: number) => (
        <span className={'creditModal__tableText'}>{index + 1}</span>
      ),
    },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'} >{t("credits.repaymentDate.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.repaymentDate.down")}</span>
      </div>,
      render: (text: string) => <span className={'creditModal__tableText'}>{moment(text, 'DD/MM/YYYY').format('DD.MM.YYYY')}</span>,
      dataIndex: 'PAYMENT_DATE',
      key: 'PAYMENT_DATE',
      // width: 100,
      ellipsis: true,
      editable: false,
    },
    // {
    //   title: <div>
    //     <span className={'creditModal__tableTitleFact'} >{t("credits.countOfDelayedDays.up")}</span>
    //     <span className={'creditModal__tableTitleFact'} >{t("credits.countOfDelayedDays.down")}</span>
    //   </div>,
    //   render: (text: string) => {
    //     return <span className={'creditModal__tableText'}>{text}</span>
    //   },
    //   dataIndex: 'DELAY_DAY_COUNT',
    //   key: 'DELAY_DAY_COUNT',
    //   editable: false,
    //   ellipsis: true,
    //   // width: 102
    // },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidDepthPrincipal.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidDepthPrincipal.down")}</span>
      </div>,
      dataIndex: 'PAID_TOTAL_DEBT',
      key: 'PAID_TOTAL_DEBT',
      // width: 120,
      render: (text: string) => {
        const totalDebt = realCreditsPlan && realCreditsPlan.reduce((a: any, v) => a + parseFloat(v['PAID_TOTAL_DEBT']), 0).toFixed(2);
        setTotalDebt(totalDebt)
        return <span className={'creditModal__tableText'}>{financial(text)}</span>
      },
    },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidInterestAmount.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidInterestAmount.down")}</span>
      </div>,
      dataIndex: 'PAID_TOTAL_INT',
      key: 'PAID_TOTAL_INT',
      // width: 120,
      render: (text: string) => {
        const paidTotalint = realCreditsPlan && realCreditsPlan.reduce((a: any, v) => a + parseFloat(v['PAID_TOTAL_INT']), 0).toFixed(2);
        setPaidTotal(paidTotalint)
        return <span className={'creditModal__tableText'}>
          {financial(text)}
        </span>
      },
    },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedDepthPrincipal.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedDepthPrincipal.middle")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedDepthPrincipal.down")}</span>
      </div>,
      // width: 150,
      dataIndex: 'PAID_DEBT_PENALTY',
      key: 'PAID_DEBT_PENALTY',
      render: (text: string) => {
        const debtPenalty = realCreditsPlan && realCreditsPlan.reduce((a: any, v) => a + parseFloat(v['PAID_DEBT_PENALTY']), 0).toFixed(2);
        setDebtPenalty(debtPenalty)
        return <span className={'creditModal__tableText'}>{text}</span>
      },
    },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedInterestAmount.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedInterestAmount.middle")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidPenaltyForDelayedInterestAmount.down")}</span>
      </div>,
      dataIndex: 'PAID_INT_PENALTY',
      key: 'PAID_INT_PENALTY',
      // width: 140,
      render: (text: string) => {
        const intPenalty = realCreditsPlan && realCreditsPlan.reduce((a: any, v) => a + parseFloat(v['PAID_INT_PENALTY']), 0).toFixed(2);
        setIntPenalty(intPenalty)
        return <span className={'creditModal__tableText'} >{text}</span>
      },
    },
    {
      title: <div>
        <span className={'creditModal__tableTitleFact'}>{t("credits.paidActualAmount.up")}</span>
        <span className={'creditModal__tableTitleFact'} >{t("credits.paidActualAmount.down")}</span>
      </div>,
      dataIndex: 'PAID_AMOUNT',
      key: 'PAID_AMOUNT',
      // width: 123,
      render: (text: string) => {
        const factMainAmount = realCreditsPlan && realCreditsPlan.reduce((a: any, v) => a + parseFloat(v['PAID_AMOUNT']), 0).toFixed(2);
        setFactPaidAmount(factMainAmount)
        return <span className={'creditModal__tableText'}>{financial(text)}</span>
      }
    },

  ]

  const tableDropDown = (
    <Menu className="hesablar_dropdown">
      <Menu.Item icon={<Icon component={() => <TableIco />} />}>
        <p onClick={(e) => handlecreditPlan(e)}>
          {t("credits.repaymentShceduleUnderContract")}
        </p>
      </Menu.Item>

      <Menu.Item icon={<Icon component={() => <FactTableIco />} />}>
        <p onClick={(e) => handlerealCreaditModal(e)}>{t("credits.actualRepaymentSchedule")}</p>
      </Menu.Item>
    </Menu>
  )

  const onRow = (item: any) =>
    expandedRowKeys.includes(item.key) && { className: 'expand-parent' }

  const onRowPanel = (item) =>
    expandedPanelTableKeys.includes(item.key) && { className: 'expand-parent' }

  const handleChange = (
    pagination: any,
    filters: any,
    sorter: React.SetStateAction<{}>
  ) => handleSorter(sorter)
  const customizeRenderEmpty = () => (
    <CustomDataEmpty value={t("credits.noLoans")} />
  )

  const onTableRowExpand = (expanded: boolean, record: any) => {
    const keys: any = []

    if (record.isExpandable === false) {
      if (expanded) {
        handleRowClose('second')
        keys.push(record.key) // I have set my record.id as row key. Check the documentation for more details.
      }
      setExpandedRowKeys(keys)
    }
  }

  const onFirstTableRowExpand = (expanded: boolean, record: any) => {
    const keys: any = []
    if (record.isExpandable === false) {
      if (expanded) {
        handleRowClose('first')
        keys.push(record.key) // I have set my record.id as row key. Check the documentation for more details.
      }
      setExpandedPanelTableKeys(keys)
    }

  }

  const handleRowClose = (type: string) => {

    // setExpandedPanelTableKeys([])
    type === 'first' ? setExpandedRowKeys([]) : setExpandedPanelTableKeys([])
  }

  const onClosePanel = () => {
    handleRowClose('second')
    setPanel(!panel)
  }

  const handleRealCreditPdf = async(e:any) => {
    setLoadingPdf(true)
    let company = getCurrentCompany()
    const data:any  = await getCreditRealPlanPdf(e,company,contractNum)
    console.log(data)
    downloadPDFFile(data?.data.fileDetailsList[0]?.fileName, data?.data.fileDetailsList[0].fileBase64);
  }
   const handleCreditPdf = async(e:any) => {
    console.log(e)
    setLoadingPdf(true)
    let company = getCurrentCompany()
    const data :any = await getCreditPlanPdf(e,company,contractNum)
    console.log(data)
    downloadPDFFile(data?.data.fileDetailsList[0]?.fileName, data?.data.fileDetailsList[0].fileBase64);
    
  }
  function downloadPDFFile(fileName: string, fileBase64: string) {
    const linkSource = `data:application/pdf;base64,${fileBase64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    setLoadingPdf(false)
}


const handleRealCreditExcel = async(e:any) => {
  setLoadingExcel(true)
  let company = getCurrentCompany()
  const data:any  = await getCreditRealPlanExcel(e,company,contractNum)
  console.log(data)
  downloadExcel(data?.data.fileDetailsList[0]?.fileName, data?.data.fileDetailsList[0].fileBase64);
}
 const handleCreditExcel = async(e:any) => {
  console.log(e)
  setLoadingExcel(true)
  let company = getCurrentCompany()
  const data :any = await getCreditPlanExcel(e,company,contractNum)
  console.log(data)
  downloadExcel(data?.data.fileDetailsList[0]?.fileName, data?.data.fileDetailsList[0].fileBase64);
  
}

function downloadExcel(fileName: string, fileBase64: string) {
  const linkSource = `data:application/vnd.ms-excel;base64,${fileBase64}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
  setLoadingExcel(false)
}

  return (
    <Spin {...tableLoading}>
      <div className={`depositList creditList ${className}`} ref={ref}>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          {tableData?.length > 0 && deactiveTableData?.length > 0 ? (
            <>
              <ActiveCreditList
                columnsData={columnsData}
                onRow={onRow}
                firstRow={firstRow}
                data={isFiltered == true ? filteredData : tableData}
                pageSize={pageSize}
                onChange={handleChange}
                expandedRowKeys={expandedRowKeys}
                onExpand={onTableRowExpand}
                handleRowClose={() => handleRowClose('first')}
              />
              <DeactiveCreditList
                panel={panel}
                columnsData={columnsData}
                onClosePanel={() => onClosePanel()}
                data={isFiltered == true ? deactiveFilteredData : deactiveTableData}
                onRowPanel={onRowPanel}
                firstRow={firstRow}
                pageSize={pageSize}
                onChange={handleChange}
                expandedRowKeys={expandedPanelTableKeys}
                onExpand={onFirstTableRowExpand}
                handleRowClose={handleRowClose}
              />
            </>
          ) : tableData?.length == 0 && deactiveTableData?.length > 0 ? (
            <DeactiveCreditList
              panel={panel}
              columnsData={columnsData}
              data={isFiltered == true ? deactiveFilteredData : deactiveTableData}
              onRowPanel={onRowPanel}
              firstRow={firstRow}
              onClosePanel={() => onClosePanel()}
              pageSize={pageSize}
              onChange={handleChange}
              expandedRowKeys={expandedPanelTableKeys}
              onExpand={onFirstTableRowExpand}
              handleRowClose={handleRowClose}
            />
          ) : (tableData?.length > 0 && deactiveTableData?.length == 0) ?
            <ActiveCreditList
              columnsData={columnsData}
              onRow={onRow}
              firstRow={firstRow}
              data={isFiltered == true ? filteredData : tableData}
              pageSize={pageSize}
              onChange={handleChange}
              expandedRowKeys={expandedRowKeys}
              onExpand={onTableRowExpand}
              handleRowClose={() => handleRowClose('first')} />
            : <><ActiveCreditList
              columnsData={columnsData}
              onRow={onRow}
              firstRow={firstRow}
              data={isFiltered == true ? filteredData : tableData}
              pageSize={pageSize}
              onChange={handleChange}
              expandedRowKeys={expandedRowKeys}
              onExpand={onTableRowExpand}
              handleRowClose={() => handleRowClose('first')} /><CustomDataEmpty value={t("credits.noLoans")} /></>
          }

        </ConfigProvider>
        <ModalComponent
          visible={tableModal}
          title={`${contractNum} №-li Kredit müqaviləsi üzrə ödəniş cədvəli`}
          width={800}
          className={'creditModal creditModalFirst'}
          footer={null}
          onCancel={() => setTableModal(false)}
        >
          <div className='responsive-creditContract-modal'>
            <TableComponent
              columns={columnsModal}
              className="creditModalTable"
              rowClassName={(record, index) => {
                const momentDate = moment(record.PAYMENT_DATE, "DD/MM/YYYY").isBefore(moment(new Date()), "day");
                return index % 2 === 0 && momentDate ? 'table-row-dark table-pastDate-color' : index % 2 === 0 && momentDate === false ? 'table-row-dark table-futureDate-color' : index % 2 !== 0 && momentDate ? 'table-row-light table-pastDate-color' : index % 2 !== 0 && momentDate === false ? 'table-row-light table-futureDate-color' : ''
              }
              }
              // tableLayout="auto"
              // ellipsis={false}
              data={creditsPlan}
              pagination={false}
              rowSelection={false}
              pageSize={pageSize}
              onChange={handleChange}
              bordered={false}
              colSpan={24}
              scroll={{ y: 600 }}
            />
            <div className={'creditModal__totalBox'}>
              <span
                className={'creditModal__totalBox-text'}
              >
                {t("credits.total")}
              </span>
              <span
                // style={{ marginLeft: 140 }}
                className={'creditModal__totalBox-text'}
              >
                {mainAmount ? financial(mainAmount) : '0.00'}
              </span>
              <span
                // style={{ marginLeft: 112 }}
                className={'creditModal__totalBox-text'}
              >
                {interestAmount ? financial(interestAmount) : '0.00'}
              </span>
              <span
                className={'creditModal__totalBox-text'}
              >
                {paidAmount ? financial(paidAmount) : '0.00'}
              </span>
            </div>
            <div className={'creditModal__footer'}>
              <DataConvert loadingExcel={loadingExcel} loadingPdf={loadingPdf} onClickExcel={handleCreditExcel}  onClickPdf={handleCreditPdf}/>
              <Button
                // style={{ width: 79, height: 40 }}
                onClick={() => setTableModal(false)}
                className="blue-button modalCloseButton"
              >
                {t("common.close")}
              </Button>
            </div>
          </div>
        </ModalComponent>
        <ModalComponent
          visible={tableModalFact}
          title={`${contractNum} №-li Kredit müqaviləsi üzrə faktiki ödəniş cədvəli`}
          width={905}
          className={'creditModal responsiveCreditModal'}
          footer={null}
          onCancel={() => setTableModalFact(false)}
        >
          <div className='responsive-credit-modal'>
            <TableComponent
              columns={columnsModalFact}
              className="creditModalFactTable"
              rowClassName={(record, index) =>
                index % 2 === 0 ? 'table-row-dark' : 'table-row-light'
              }
              data={realCreditsPlan}
              pagination={false}
              rowSelection={false}
              pageSize={pageSize}
              // width={400}
              onChange={handleChange}
              // ellipsis
              ellipsis={true}
              bordered={false}
              colSpan={24}
              tableLayout="auto"
              scroll={{ y: 600 }}
            />
            <div className={'creditModal__totalBoxFact'}>
              <span
                // style={{ marginLeft: 30 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {t("credits.total")}
              </span>
              <span
                // style={{ marginLeft: 139 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {totalDebt ? financial(totalDebt) : '0.00'}
              </span>
              <span
                // style={{ marginLeft: 60 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {paidTotalint ? financial(paidTotalint) : '0.00'}
              </span>
              <span
                // style={{ marginLeft: 110 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {debtPenalty ? financial(debtPenalty) : '0.00'}
              </span>
              <span
                // style={{ marginLeft: 109 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {intPenalty ? financial(intPenalty) : '0.00'}
              </span>
              <span
                // style={{ marginLeft: 100 }}
                className={'creditModal__totalBoxFact-text'}
              >
                {factPaidAmount ? financial(factPaidAmount) : '0.00'}
              </span>
            </div>
            <div className={'creditModal__footer'}>
              <DataConvert loadingExcel={loadingExcel} loadingPdf={loadingPdf} onClickExcel={handleRealCreditExcel}  onClickPdf={handleRealCreditPdf} />
              <Button
                style={{ height: 40 }}
                onClick={() => setTableModalFact(false)}
                className="blue-button modalCloseButton"
              >
                {t("common.close")}
              </Button>
            </div>
          </div>
        </ModalComponent>
        {/* <div className={'creditList__dataConvertBox'}>
          <DataConvert />
        </div> */}
      </div>
    </Spin>
    // </>
  )
}

export default connect(null, null)(CreditList)
